import { SalesOrderConfirmationReportLine } from './sales-order-confirmation-report-line';
import { SellingCompanyReport } from '../../../../tms-shared';
import { SalesOrderDeliveryReport } from './sales-order-delivery-report';
import { SalesOrderExtraReport } from './sales-order-extra-report';
import { SalesOrderVatAnalysis } from './sales-order-vat-analysis';
import { PickingListReportWarehouse } from './picking-list-report-warehouse';
import { OrderPropertyReport } from './order-property-report';

export interface SalesOrderConfirmationReport {
  id: string;
  orderNo: number;
  orderType: string;
  customerKey: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  customerConfirmationEmailAddress: string;
  currency: string;
  currencySymbol: string;
  dateOrdered?: Date;
  dateOrderedString: String;
  enteredBy: string;
  customerAddress: string;
  deliveryAddress: string;
  deliveryAddressHtml: string;
  paymentTerms: string;
  deliveryTerms: string;
  modeOfTransport: string;
  shipper: string;
  nettValue: number;
  taxRate: number;
  taxValue: number;
  overallValue: number;
  vatAnalysis: string;
  documentNotes: string;
  deliveryInstructions: string;
  deliveryTermNotes: string;
  deliveredFrom: string;
  deliveredFromHtml: string;
  shippingNotes: string;
  agentName: string;
  deliveryAddressee: string;
  printDeliveryAddress: boolean;
  documentMessage: string;
  sellingCompany: SellingCompanyReport;
  useConfirmationAsPickingList: boolean;
  salesOrderLines: SalesOrderConfirmationReportLine[];
  salesOrderDeliveryItems: SalesOrderDeliveryReport[];
  salesOrderExtraItems: SalesOrderExtraReport[];
  salesOrderVatAnalysis: SalesOrderVatAnalysis[];
  salesOrderProperties: OrderPropertyReport[];
  pickingListWarehouses: PickingListReportWarehouse[];
  orderedBy: string;
  showVatAnalysisOnDocuments: boolean;
}
